import React from 'react';
import { IconPropsType } from '../../misc/types';

const Info = (props: IconPropsType) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" stroke='currentColor' className={props.additionalStyle} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 8H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 12H12V16H13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default Info;
